<template>
  <v-row>
    <v-col cols="12">
      <BaseBlock title="Gestion des types de pièce">
        <v-row>
          <v-col cols="12" md="4">
            <router-link
              :to="{
                name: 'form-typePiece',
                params: {
                  idTypePiece: 0
                }
              }"
              tag="v-btn"
            >
              <v-icon title="Ajouter un type de pièce">mdi-plus</v-icon>
              Ajouter un type de pièce</router-link
            >
          </v-col>
        </v-row>
        <v-row v-if="listeTypesPiece.length > 0">
          <v-col cols="12" md="6" offset="0" offset-md="3">
            <v-data-table
              :headers="headers"
              :items="listeTypesPiece"
              disable-pagination
              hide-default-footer
              item-key="id"
              disable-sort
              class="elevation-1"
            >
              <template v-slot:item.commun="{ item }">
                <v-icon v-if="item.commun == true" class="mr-2"
                  >mdi-check-bold</v-icon
                >
                <v-icon v-else>mdi-close</v-icon>
              </template>
              <template v-slot:item.action="{ item }">
                <router-link
                  :to="{
                    name: 'form-typePiece',
                    params: {
                      idTypePiece: item.id
                    }
                  }"
                >
                  <v-icon
                    class="mr-2"
                    title="Éditer le type de pièce"
                    color="primary"
                    >mdi-pencil</v-icon
                  ></router-link
                >

                <ActionConfirmation
                  icone="mdi-delete"
                  title="Supprimer le type de pièce"
                  @ok="deleteTypePiece(item.id)"
                ></ActionConfirmation>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import ApiTypePieceRepository from "@/repositories/ApiTypePieceRepository";
import ActionConfirmation from "@/components/ActionConfirmation";

export default {
  name: "ListeTypesPiece",
  components: { BaseBlock, ActionConfirmation },

  data() {
    return {
      headers: [
        {
          text: "Libellé",
          align: "left",
          value: "libelle"
        },
        {
          text: "Libellé court",
          align: "left",
          value: "libelleCourt"
        },
        {
          text: "Commun",
          align: "center",
          value: "commun"
        },
        {
          text: "Actions",
          align: "center",
          value: "action",
          width: "20%"
        }
      ],
      listeTypesPiece: [],
      loading: false
    };
  },
  created() {
    this.getTypeDiplomes();
  },
  methods: {
    async getTypeDiplomes() {
      try {
        const typesPieces = await ApiFormationRepository.getTypesPieces();
        this.listeTypesPiece = typesPieces;
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async deleteTypePiece(idTypePiece) {
      try {
        await ApiTypePieceRepository.deleteTypePiece(idTypePiece);

        let removeIndex = this.listeTypesPiece
          .map(item => item.id)
          .indexOf(idTypePiece);

        this.listeTypesPiece.splice(removeIndex, 1);

        this.$toast.success("Le type de pièce a été supprimé.");
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    }
  }
};
</script>
